import React from "react";
import ClientProspectViewToggle from "../../components/Buttons/ToggleButton/ClientProspectViewToggle";
import { Menu, MenuItem, Button } from "@mui/material";
import ClientSearch from "../../components/Search/ClientSearch";
import {
    HiOutlineAdjustmentsHorizontal,
    HiArrowsUpDown,
    HiMiniPlus,
} from "react-icons/hi2";

const ClientHeader = ({
    user_id,
    allClients,
    showLeads,
    toggleShowLeads,
    setIsCreateModalOpen,
    isFilterOpen,
    setIsFilterOpen,
    sortOption,
    setSortOption,
}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [sortBy, setSortBy] = React.useState<boolean>(false);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setSortBy(!sortBy);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSort = (option: string) => {
        setSortOption(option);
        handleClose();
    };

    return (
        <div className="w-full flex flex-col gap-6 px-3 md:px-1 md:pl-5 mt-10 md:mt-20 md:mb-5">
            <div className="flex justify-between w-full">
                <h1 className={` text-xxl text-black font-bold`}>Clients</h1>
                <div className="hidden md:block">
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => setIsCreateModalOpen(true)}
                    >
                        <span
                            className=" py-1 px-1 text-base flex items-center gap-2"
                            style={{
                                fontWeight: 505,
                            }}
                        >
                            <HiMiniPlus style={{ strokeWidth: 1.1 }} /> Créer
                            Prospect
                        </span>
                    </Button>
                </div>
            </div>
            <div className="flex flex-col md:flex-row gap-3 w-full justify-between items-center">
                <div className="flex w-full md:w-1/3 justify-between md:justify-start">
                    <ClientProspectViewToggle
                        viewMode={showLeads ? "prospects" : "clients"}
                        onChange={toggleShowLeads}
                    />
                    <div className=" md:hidden">
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => setIsCreateModalOpen(true)}
                        >
                            <span className=" py-1 px-1 text-sm md:text-base flex items-center gap-2">
                                <HiMiniPlus style={{ strokeWidth: 1.1 }} />{" "}
                                Créer Prospect
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="gap-2 w-full md:w-2/3  justify-between md:justify-end flex h-full">
                    <div className=" w-3/4 md:w-2/3 h-full">
                        <ClientSearch
                            user_id={user_id}
                            allClients={allClients}
                        />
                    </div>
                    <div>
                        <Button
                            id="basic-button"
                            variant="contained"
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClick}
                            sx={{
                                height: 45,
                                backgroundColor: "#3e3e3e",
                                width: {
                                    xs: "45px",
                                    md: "auto",
                                },
                                padding: {
                                    xs: "0px",
                                    md: "5px 15px",
                                },
                                minWidth: {
                                    xs: "45px",
                                    md: "auto",
                                },
                            }}
                        >
                            <span className="text-sm flex items-center gap-2 text-white">
                                <HiArrowsUpDown style={{ strokeWidth: 1.1 }} />
                                <span className="hidden md:block">
                                    Trier par
                                </span>
                            </span>
                        </Button>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                                sx: {
                                    boxShadow:
                                        "1px 1px 1px 1px rgba(0, 0, 0, 0.1)",
                                    borderRadius: "8px",
                                },
                            }}
                        >
                            <MenuItem
                                onClick={() =>
                                    handleSort(
                                        !sortOption ||
                                            !sortOption.startsWith("name")
                                            ? "name_asc"
                                            : sortOption === "name_asc"
                                              ? "name_desc"
                                              : null
                                    )
                                }
                                className={
                                    sortOption?.startsWith("name")
                                        ? "bg-gray-100"
                                        : ""
                                }
                            >
                                Nom{" "}
                                {sortOption === "name_asc"
                                    ? "↑"
                                    : sortOption === "name_desc"
                                      ? "↓"
                                      : ""}
                            </MenuItem>
                            <MenuItem
                                onClick={() =>
                                    handleSort(
                                        !sortOption ||
                                            !sortOption.startsWith("alert")
                                            ? "alert_desc"
                                            : sortOption === "alert_desc"
                                              ? "alert_asc"
                                              : sortOption === "alert_asc"
                                                ? null
                                                : "alert_desc"
                                    )
                                }
                                className={
                                    sortOption?.startsWith("alert")
                                        ? "bg-gray-100"
                                        : ""
                                }
                            >
                                Alerte{" "}
                                {sortOption === "alert_desc"
                                    ? "↓"
                                    : sortOption === "alert_asc"
                                      ? "↑"
                                      : ""}
                            </MenuItem>
                            <MenuItem
                                onClick={() =>
                                    handleSort(
                                        !sortOption ||
                                            !sortOption.startsWith(
                                                "last_meeting_start_date"
                                            )
                                            ? "last_meeting_start_date_desc"
                                            : sortOption ===
                                                "last_meeting_start_date_desc"
                                              ? "last_meeting_start_date_asc"
                                              : sortOption ===
                                                  "last_meeting_start_date_asc"
                                                ? null
                                                : "last_meeting_start_date_desc"
                                    )
                                }
                                className={
                                    sortOption?.startsWith(
                                        "last_meeting_start_date"
                                    )
                                        ? "bg-gray-100"
                                        : ""
                                }
                            >
                                Date interaction{" "}
                                {sortOption === "last_meeting_start_date_desc"
                                    ? "↓"
                                    : sortOption ===
                                        "last_meeting_start_date_asc"
                                      ? "↑"
                                      : ""}
                            </MenuItem>
                        </Menu>
                    </div>
                    <Button
                        onClick={() => setIsFilterOpen((prev) => !prev)}
                        variant="contained"
                        color="secondary"
                        sx={{
                            height: 45,
                            backgroundColor: isFilterOpen ? "white" : "#3e3e3e",
                            width: {
                                xs: "45px",
                                md: "auto",
                            },
                            padding: {
                                xs: "0px",
                                md: "5px 15px",
                            },
                            minWidth: {
                                xs: "45px",
                                md: "auto",
                            },
                        }}
                    >
                        <span
                            className={`text-sm flex items-center gap-2 hover:text-black ${isFilterOpen ? "text-black" : "text-white"}`}
                        >
                            <HiOutlineAdjustmentsHorizontal
                                size={17}
                                style={{ strokeWidth: 1.8 }}
                            />{" "}
                            <span className="hidden md:block">Filtres</span>
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ClientHeader;
